import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Tooltip } from 'primeng/tooltip';
import { AuthService } from '../../../auth/services/auth.service';
import { UserStore } from '../../../auth/store/user.store';

@Component({
  selector: 'app-user-section',
  imports: [Tooltip, RouterLink],
  templateUrl: './user-section.component.html',
  styleUrl: './user-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserSectionComponent {
  private authService = inject(AuthService);
  private userStore = inject(UserStore);

  protected userName = this.userStore.userName;
  protected branches = this.userStore.selectedBranches;
  protected roles = this.userStore.roles;
  protected ghrTitle = this.userStore.ghrTitle;
  protected roleMismatch = this.userStore.roleMismatch;
  protected mismatchWarnings = this.userStore.mismatchWarnings;

  logout() {
    this.authService.logout();
  }
}
